var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvent1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4063 15.2966L15.7026 16.7157L14.3144 21.8944L16.2369 21.2626L17.5847 22.7719L18.9729 17.5909L24.2704 19.0111C24.6504 19.1132 24.8783 19.5075 24.7762 19.8875L22.058 30.0299C21.9559 30.4099 21.5617 30.6391 21.1805 30.537L7.31763 26.8237C6.93763 26.7215 6.70963 26.3273 6.81175 25.9473L9.52994 15.8037C9.63087 15.4237 10.0263 15.1957 10.4063 15.2966Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5781 36.1372C23.5781 33.4558 25.7595 31.2744 28.4409 31.2744C31.1211 31.2744 33.3025 33.4558 33.3025 36.1372C33.3025 38.8186 31.1211 41 28.4397 41C25.7595 41 23.5781 38.8186 23.5781 36.1372ZM26.6466 36.1372C26.6466 37.1264 27.4505 37.9315 28.4409 37.9315C29.4301 37.9315 30.234 37.1264 30.234 36.1372C30.234 35.148 29.4301 34.3429 28.4409 34.3429C27.4505 34.3441 26.6466 35.148 26.6466 36.1372Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86269 30.5631L22.7517 36.7108C22.7327 36.5232 22.7232 36.332 22.7232 36.1384C22.7232 34.3334 23.5651 32.7243 24.8761 31.6758L26.2548 26.433L30.6212 27.6442L29.9669 30.6355C30.6592 30.8279 31.2969 31.1473 31.8574 31.5665L33.989 21.8172L30 15L31 12L32 9C32.5 8.5 32 7.5 31.5 7.5C30.5 7.5 29.5 8 29.2413 9.00001L26.7749 16.5L22.6317 32.1579L9.39113 28.5871C8.84251 28.4398 8.28438 28.7652 8.13832 29.3103C7.99226 29.8553 8.31644 30.417 8.86269 30.5631ZM26.7749 24.4534L28.5621 17.6597L31.7992 22.2565L31.0606 25.6397L26.7749 24.4534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvent1);
export default __webpack_public_path__ + "static/media/invent1.2074fcddd22267073b6e8f3bc87ca7aa.svg";
export { ForwardRef as ReactComponent };